import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  relatedAccounts,
  relatedAccountsSearchLoading,
} from "../dealer-search/DealerSlice";
import { Button, Card, Col, Form, Spinner } from "@deere/ux.uxframe-react";
import {
  expirationReportError,
  expirationReportList,
  expirationReportLoading,
  getExpirationReport,
  setExpirationSearchQueryObject,
} from "./expirationReportSlice";
import { ExpirationReportList } from "./ExpirationReportList";
import { languageResponseData } from "../Translation/translationSerachSlice";
import { DateRangePicker, InputAdornment, ThemeProvider } from "@deere/fuel-react";
import { CalendarMonth } from "@mui/icons-material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ExpirationReport = () => {
  const dispatch = useDispatch();
  const [dealerId, setDealerId] = useState([]);
  const [model, setModel] = useState("");
  const [serial, setSerial] = useState("");
  const [expirationDate, setExpirationDate] = useState(null);
  const history = useHistory();

  const relatedAccountList = useSelector(relatedAccounts);
  const relatedAccountsLoading = useSelector(relatedAccountsSearchLoading);

  const expirationSearchLoading = useSelector(expirationReportLoading);
  const expirationReportData = useSelector(expirationReportList);
  const expirationReportSearchError = useSelector(expirationReportError);

  const [expirationSearchPayload, setExpirationSearchPayload] = useState(null);

  const translationsResponse = useSelector(languageResponseData);
  const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
  };

  let relatedAccountOptions = [];
  if (relatedAccountList && relatedAccountList.length) {
    relatedAccountOptions = relatedAccountList.map((relatedAccount) => {
      const optionValue = `${relatedAccount.accountId} - ${
        relatedAccount.physicalAddressCity
          ? relatedAccount.physicalAddressCity + ", "
          : ""
      }${
        relatedAccount.physicalAddressState
          ? relatedAccount.physicalAddressState + " "
          : ""
      }${
        relatedAccount.physicalAddressCountry
          ? relatedAccount.physicalAddressCountry
          : ""
      }`;

      return (
        <option
          key={relatedAccount.accountId}
          defaultselected={dealerId
            .includes(relatedAccount.accountId)
            .toString()}
          onClick={() => handleItemClick(relatedAccount.accountId)}
          value={dealerId.includes(relatedAccount.accountId)}
        >
          {optionValue}
        </option>
      );
    });
  }

  const handleItemClick = (item) => {
    setDealerId((prevDealerIds) => {
      return prevDealerIds.includes(item)
        ? prevDealerIds.filter(
            (selectedDealerIds) => selectedDealerIds !== item
          )
        : [...prevDealerIds, item];
    });
  };

  const onExpirationSearchSubmit = (event) => {
    event.preventDefault();
      const confirmSearch = window.confirm;
      // eslint-disable-next-line no-lone-blocks
      {
        translate(
          "message7",
          "Search may take longer time to complete. Narrowing your search will improve the response. Press OK to continue with the current search criteria or Cancel to add more filters."
        );
      }
      if (confirmSearch) {
        const expirationSearchQueryObj = {
          dealerIdList: dealerId,
          model: model,
          serial: serial,
          initialExpiryDateRange: expirationDate
            ? expirationDate[0]?.toISOString()
            : null,
          finalExpiryDateRange: expirationDate
            ? expirationDate[1]?.toISOString()
            : null,
        };

        let expirationReportSearchObj = {
          expirationReportQueryObj: expirationSearchQueryObj,
          pageSize: 200,
          pageNumber: 1,
        };
        setExpirationSearchPayload(expirationReportSearchObj);
        dispatch(setExpirationSearchQueryObject(expirationSearchQueryObj));
        dispatch(getExpirationReport(expirationReportSearchObj));
      }
     
  };

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (location.pathname === "/expiration-report") {
        setDealerId([]);
        setModel("");
        setSerial("");
        setExpirationDate([]);
      }
    });

    return () => {
      unlisten();
    };
  }, [dispatch, history]);

  return (
    <>
      {relatedAccountsLoading ? (
        <div className="d-flex w-100 justify-content-center align-items-center">
          <Spinner
            accessibilityLabel="Loading"
            className="uxf-spinner-border-lg"
            animation="border"
          />
        </div>
      ) : (
        <>
          <Card>
            <Card.Body>
              <Form onSubmit={onExpirationSearchSubmit}>
                <Form.Row>
                  <Form.Group as={Col} controlId="formGridDealer">
                    <Form.Label className="uxf-label">
                      {translate("dealer", " Dealer")}
                      <span
                        aria-label="field required"
                        className="uxf-is-required"
                      >
                        *
                      </span>
                    </Form.Label>
                    {relatedAccountList && relatedAccountList.length ? (
                      <>
                        <Form.Control required as="select" multiple>
                          <option key="-1">
                            {translate(
                              "Select single or multiple dealer ids....",
                              "Select single or multiple dealer ids...."
                            )}
                          </option>
                          {relatedAccountOptions}
                        </Form.Control>

                        <div style={{ marginTop: "20px" }}>
                          <strong>
                            {translate(
                              "selected_dealer_id",
                              "Selected Dealer Ids:"
                            )}
                          </strong>
                          {dealerId.join(", ")}
                        </div>
                      </>
                    ) : (
                      <Form.Control
                        required
                        placeholder={translate(
                          "enter_dealer_account",
                          "Enter Dealer Account Number"
                        )}
                        onChange={(e) =>
                          setDealerId([
                            e.target.value.replace(/\s/g, "").toUpperCase(),
                          ])
                        }
                        maxLength="6"
                        value={dealerId}
                      />
                    )}
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridModel">
                    <Form.Label className="uxf-label">
                      {translate("model", " Model")}
                    </Form.Label>
                    <Form.Control
                      placeholder={translate("enter_model", " Enter Model")}
                      onChange={(e) => setModel(e.target.value)}
                      maxLength="10"
                      value={model}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label className="uxf-label">
                      {translate(
                        "expiration_date_between",
                        "Expiration Date Between"
                      )}
                    </Form.Label>
                    <ThemeProvider>

                    <DateRangePicker
                      EndInputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarMonth />
                          </InputAdornment>
                        ),
                      }}
                      StartInputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarMonth />
                          </InputAdornment>
                        ),
                      }}
                      endDatePlaceholder="Select End Date"
                      startDatePlaceholder="Select Start Date"
                      onChange={(date) => setExpirationDate(date)}
                      value={expirationDate}
                    /></ThemeProvider>
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridSerialNumber">
                    <Form.Label className="uxf-label">
                      {translate("serial_number", "Serial Number")}
                    </Form.Label>
                    <Form.Control
                      placeholder={translate(
                        "enter_serial_no",
                        "Enter Serial Number"
                      )}
                      onChange={(e) => setSerial(e.target.value)}
                      maxLength="6"
                      value={serial}
                    />
                  </Form.Group>
                </Form.Row>
                <Button variant="primary" type="submit">
                  {translate("search", "Search")}
                </Button>
              </Form>
              {expirationReportSearchError ? (
                <span
                  style={{
                    color: "red",
                    marginTop: 0.5,
                    fontSize: 20,
                    marginLeft: 300,
                  }}
                >
                  No reports found for this criteria
                </span>
              ) : (
                <></>
              )}
            </Card.Body>
          </Card>
          {expirationSearchLoading ? (
            <div className="d-flex w-100 justify-content-center align-items-center">
              <Spinner
                accessibilityLabel="Loading"
                className="uxf-spinner-border-lg"
                animation="border"
              />
            </div>
          ) : expirationReportData.length > 0 ? (
            <>
              <Card>
                <Card.Header>
                  {translate("expiration_report1", "Expiration Report")}
                </Card.Header>
                <Card.Body>
                  <ExpirationReportList
                    expirationSearchPayload={expirationSearchPayload}
                  />
                </Card.Body>
              </Card>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default ExpirationReport;
